module.exports = __webpack_public_path__ + "static/p08_cerdoGrandeOrejaDer-de50abf81347a115770a860a0b80118b.png";